import React, { useState } from "react";
import "../listing/listing.css";
import Head from  "../../../Header/head.js";
import "../../../../common/css/common.css";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { debatesList } from "../../../../redux/actions/debates_listing";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../../../services/axios";
import { ToastContainer, toast } from 'react-toastify';
import { getRemainingDebateAction } from "../../../../redux/actions/check_remaining_debate_action.js";




function Listing(){
    const auth = useSelector((state)=>state.jwtAuthreducer);
    const debates = useSelector((state)=>state.debateListReducer);
    const total_debates_left = useSelector((state)=>state.getRemainingDebateReducer);

    const navigate = useNavigate();
    const [virtualId,setVirtualId] = useState(false);
    const dispatch = useDispatch();
    const notificaton = ()=>{
        toast('You have already started one debate kindly leave or finish that first', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
    }

    useEffect(()=>{
        if(auth.user){
         dispatch(debatesList())
         dispatch(getRemainingDebateAction())
         console.log(total_debates_left,"remaining debate from debate listing.")
        }
    },[auth])
    console.log(total_debates_left,"frdfadfasdasdsa")
    const debates_list = debates.debates;

    const startDebate =async (debate_id,room_id)=>{
        try{
            await axiosInstance.post(`/mediator/start`,{"debate_id":debate_id,"started":true}).then(
                (response)=>{
                    let {data} = response
                    if(data.exist){
                        notificaton()
                    }
                    else{
                        // console.log(response,"from listing response")
                        navigate("/mediator",{state:{debate_id:debate_id,room_id:room_id,virtual_id:response.data.virtaul_id}})
                    }
                }
            );
        }   
        catch(err){
            throw(err)
        }
    }
    

    return(
     <>   
     {auth.isAuthenticated === false
     ?
     navigate("/login")
     :
    <>
        <Head/>
    <div className="inner-page-wrapper">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-md-4 fixedDiv" >
                    <ul className="nav list-tabs d-flex flex-md-column" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a className="nav-link active" id="upcomingDebates-tab" data-toggle="tab"
                                href="#upcomingDebates" role="tab" aria-controls="upcomingDebates" aria-selected="true">
                                Upcoming Debates
                                <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.79426 8.42914L1.22881 0.220564C0.947759 -0.0735207 0.491893 -0.0735207 0.210804 0.220564C-0.0702847 0.514647 -0.0702513 0.991753 0.210804 1.28584L8.25981 9.00001L0.211506 16.7142C-0.0695491 17.0083 -0.0695491 17.4854 0.211506 17.7795C0.492561 18.0735 0.948428 18.0735 1.22948 17.7795L9.79496 9.57088C9.94477 9.41412 10.009 9.20628 9.99899 9.00075C10.0083 8.79445 9.9441 8.58665 9.79423 8.42911L9.79426 8.42914Z"
                                        fill="currentColor" />
                                </svg>
                            </a>
                        </li>


                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="pastDebates-tab" data-toggle="tab" href="#pastDebates" role="tab"
                                aria-controls="pastDebates" aria-selected="false">
                                Past Debates
                                <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.79426 8.42914L1.22881 0.220564C0.947759 -0.0735207 0.491893 -0.0735207 0.210804 0.220564C-0.0702847 0.514647 -0.0702513 0.991753 0.210804 1.28584L8.25981 9.00001L0.211506 16.7142C-0.0695491 17.0083 -0.0695491 17.4854 0.211506 17.7795C0.492561 18.0735 0.948428 18.0735 1.22948 17.7795L9.79496 9.57088C9.94477 9.41412 10.009 9.20628 9.99899 9.00075C10.0083 8.79445 9.9441 8.58665 9.79423 8.42911L9.79426 8.42914Z"
                                        fill="currentColor" />
                                </svg>
                            </a>
                        </li>


                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="savedDebates-tab" data-toggle="tab" href="#savedDebates" role="tab"
                                aria-controls="savedDebates" aria-selected="false">
                                Saved Debates
                                <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.79426 8.42914L1.22881 0.220564C0.947759 -0.0735207 0.491893 -0.0735207 0.210804 0.220564C-0.0702847 0.514647 -0.0702513 0.991753 0.210804 1.28584L8.25981 9.00001L0.211506 16.7142C-0.0695491 17.0083 -0.0695491 17.4854 0.211506 17.7795C0.492561 18.0735 0.948428 18.0735 1.22948 17.7795L9.79496 9.57088C9.94477 9.41412 10.009 9.20628 9.99899 9.00075C10.0083 8.79445 9.9441 8.58665 9.79423 8.42911L9.79426 8.42914Z"
                                        fill="currentColor" />
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-lg-9 col-md-8">
                    <div className="tab-content debate-list-box" id="myTabContent">
                        <div className="tab-pane fade show active" id="upcomingDebates" role="tabpanel" aria-labelledby="upcomingDebates-tab">
                        
                        {debates_list ? 
                        
                        <>
                         {debates_list.map((element,index)=>(
                            <div key={index} className="debate-list-card">
                                <div className="debate-list-card-outer">
                                    <ul className="debate-list-card-info mb-0">
                                        <li>
                                            <span>Title</span>
                                            <div className="text">{element.title}</div>
                                        </li>
                                        <li>
                                            <span>Duration</span>
                                            <div className="text">{element.total_hour}:{element.total_minutes}</div>
                                        </li>
                                        <li>
                                            <span>No. of participants</span>
                                            <div className="text">{element.members_each_side}</div>
                                        </li>
                                    </ul>
                                    <div className="btn-wrap">
                                        <span  onClick={()=>startDebate(element.debate_id,element.room_id)} className="btn btn-primary">
                                            <svg className="mr-2" width="8" height="12" viewBox="0 0 8 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M0 11.629V0.371034C0 0.225802 0.0867066 0.0940984 0.221835 0.0334738C0.35712 -0.0266896 0.515934 -0.00449987 0.628689 0.0899474L7.86757 5.62575C7.95081 5.69575 7.99844 5.79717 7.99996 5.90443C8.00122 6.00723 7.95364 6.11366 7.87193 6.18449L0.633258 11.906C0.521133 12.0035 0.361269 12.0272 0.224723 11.9675C0.0881246 11.9075 0 11.7749 0 11.629Z"
                                                    fill="white" />
                                            </svg>
                                            Start Now
                                        </span>
                                        <a href="#" className="save-debate-link">
                                            Save Debate
                                        </a>
                                    </div>
                                    <a href="#" className="edit-link">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7.4619 2.02218L9.90297 4.46323L3.72394 10.6423L1.28425 8.20121L7.4619 2.02218ZM11.7553 1.43346L10.6666 0.344834C10.2459 -0.075882 9.56277 -0.075882 9.14063 0.344834L8.09784 1.38763L10.5389 3.8287L11.7553 2.61234C12.0816 2.28601 12.0816 1.75977 11.7553 1.43346ZM0.00679293 11.6323C-0.0376314 11.8322 0.142879 12.0114 0.342834 11.9628L3.063 11.3032L0.623311 8.86217L0.00679293 11.6323Z"
                                                fill="currentColor" />
                                        </svg>
                                    </a>
                                </div>
                                <div className="debate-code-wrap d-flex">
                                    <div className="debate-code">
                                        Participants Code:
                                        <span>{element.participants_code}</span>
                                    </div>
                                    <div className="debate-code">
                                        Audience Code:
                                        <span>{element.audience_code}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </>
                        
                        :"No Result Found"}
                       
                          
                          

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Link to={total_debates_left.debates > 0 ? "/create":"/subscription"} className="create-new-debate-btn">
    <span>+</span>
        Create new debate
    </Link>
    </>
    }
    </>
    );
}

export default Listing;